import { Action, createReducer, on } from '@ngrx/store';

import * as MineralActions from './mineral.actions';
import { MineralModuleState } from '../models/mineral.model';

export const initialState: MineralModuleState = {
  mineralLegalNoticeVisible: true,
} as MineralModuleState;

const reducer = createReducer(
  initialState,
  on(MineralActions.setMineralLegalNoticeVisibility, (state, { visible }) => ({
    ...state,
    mineralLegalNoticeVisible: visible,
  })),
);

export const mineralReducer = (state: MineralModuleState | undefined, action: Action) =>
  reducer(state, action);
